/** Минские точки самовывоза (как в ai.1akb.by assistant stores-info). */
export const MINSK_PICKUP_STORES = [
  {
    warehouse: 'Карвата',
    title: 'Ваупшасова',
    address: 'г. Минск, ул. Ваупшасова, 10',
    hours: 'Пн–Пт 8:30–20:00, Сб–Вс 9:00–20:00',
  },
  {
    warehouse: 'Володько',
    title: 'Володько',
    address: 'г. Минск, ул. Володько, 9',
    hours: 'Пн–Пт 9:00–20:00, Сб–Вс 9:00–19:00',
  },
  {
    warehouse: 'Машинка',
    title: 'Машиностроителей',
    address: 'г. Минск, ул. Машиностроителей, 9',
    hours: 'Пн–Пт 9:00–20:00, Сб–Вс 9:00–19:00',
  },
  {
    warehouse: 'Бельского',
    title: 'Бельского',
    address: 'г. Минск, ул. Бельского, 14',
    hours: 'Пн–Пт 9:00–20:00, Сб–Вс 9:00–19:00',
  },
];

export function isMinskCity(city) {
  const c = String(city || '').trim().toLowerCase();
  return c === 'минск' || c === 'minsk' || c.includes('минск');
}
